var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99 0.364746C4.47 0.364746 0 4.84475 0 10.3647C0 15.8847 4.47 20.3647 9.99 20.3647C15.52 20.3647 20 15.8847 20 10.3647C20 4.84475 15.52 0.364746 9.99 0.364746ZM10 18.3647C5.58 18.3647 2 14.7847 2 10.3647C2 5.94475 5.58 2.36475 10 2.36475C14.42 2.36475 18 5.94475 18 10.3647C18 14.7847 14.42 18.3647 10 18.3647ZM13.5 9.36475C14.33 9.36475 15 8.69475 15 7.86475C15 7.03475 14.33 6.36475 13.5 6.36475C12.67 6.36475 12 7.03475 12 7.86475C12 8.69475 12.67 9.36475 13.5 9.36475ZM6.5 9.36475C7.33 9.36475 8 8.69475 8 7.86475C8 7.03475 7.33 6.36475 6.5 6.36475C5.67 6.36475 5 7.03475 5 7.86475C5 8.69475 5.67 9.36475 6.5 9.36475ZM10 15.8647C12.33 15.8647 14.31 14.4047 15.11 12.3647H4.89C5.69 14.4047 7.67 15.8647 10 15.8647Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.09b4f818.svg";
export { ForwardRef as ReactComponent };